import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const OnboardingVideoContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 3rem;
	margin-top: 2rem;
	flex-direction: column;
	align-items: center;
	text-align: center;

	& > span:nth-of-type(1) {
		width: 50%;

		@media ${Breakpoints.mobile} {
			width: 80%;
			font-size: 3rem !important;
		}
	}

	& > img {
		@media ${Breakpoints.mobile} {
			width: 70%;
		}
	}

	& > button:last-of-type {
		margin-bottom: 3rem;
	}

	& > span:nth-of-type(2) {
		width: 80%;
		@media ${Breakpoints.mobile} {
			width: 90%;
			font-size: 2rem !important;
		}
	}
`;

export const OnboardingVideoOuterContainer = styled.div`
	background-image: url('https://storage.googleapis.com/tryoto-public/onboarding/bg-right-side.png');
	background-position: right;
	background-repeat: no-repeat;
	background-size: cover;
	background-color: var(--blue);
	padding: var(--padding-3);

	> img {
		position: absolute;
	}

	@media ${Breakpoints.mobile} {
		background-size: 400px 100%;

		> img {
			display: none;
		}
	}
`;

export const OnboardingVideoPageContainer = styled.div`
	padding: var(--padding-3);
	width: 100%;
	display: flex;
	gap: 3rem;
	margin-top: 2rem;
	flex-direction: column;
	align-items: center;
	text-align: center;
	& > span:nth-of-type(2) {
		width: 90%;
	}
`;

export const SkipCss = css`
	color: var(--white);
	background-color: transparent !important;
	border: 0 !important;
	text-decoration: underline;
	padding: 0 !important;
`;
